<style lang="less" scoped>
  .number {
    margin-top: 12px;
  }
  .title-component {
    width: 180px;
    height: 180px;
    background-color: #ffa000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .title-area {
      font-size: 44px;
    }
  }
  .title-area {
    color: white;
    text-align: center;
    font-size: 56px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
  }
  .start-button {
    margin-top: 24px;
  }
</style>

<template lang="pug">
  .time-number.std-layout
    .header
      header-component(
        @click-back='redirectBack'
        @click-start='start')
    .content
      .title-component
        .title-area
          div 스피드
          div 넘버
    .footer
      number-component.number(
        :name='"숫자"'
        :unit='"개"'
        :max='300'
        :default='number'
        @change='number = $event')
      number-component.number(
        :name='"기억"'
        :unit='"분"'
        :min='5'
        :max='5'
        @change='time = $event')
      number-component.number(
        :name='"단위"'
        :unit='"개"'
        :max='3'
        @change='units = $event')
      number-component.number(
        :name='"리콜"'
        :unit='"분"'
        :default='recall'
        @change='recall = $event')
      button-component.start-button(
        :text='"시작하기"'
        @click.native='start')
</template>

<script>
import HeaderComponent from '@/components/header/back_start';
import TitleComponent from '@/components/time_attack_title';
import ButtonComponent from '@/components/button';
import NumberComponent from '@/components/number';

import GameType from '@/game';

export default {
  data() {
    return {
      number: 100,
      time: 5, // 기본 값이 5분
      units: 1,
      recall: 15,
      mode: GameType.mode.training,
      game: GameType.game.number,
    };
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    start() {
      const answer = this.numberGame.init(this.number, this.units);
      this.$store.commit('setCount', this.number);
      this.$store.commit('setTime', this.time);
      this.$store.commit('setUsedTime', this.time * 60); // 외우는 시간을 기준으로 강제 설정
      this.$store.commit('setUnits', this.units);
      this.$store.commit('setMode', this.mode);
      this.$store.commit('setGame', this.game);
      this.$store.commit('setRecall', this.recall);
      this.$store.commit('setAnswer', answer);
      this.$router.push({ name: 'TrainingNumberStart' });
    },
  },
  components: {
    HeaderComponent,
    TitleComponent,
    ButtonComponent,
    NumberComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/number/index.vue